import { render, staticRenderFns } from "./BundleSelection.vue?vue&type=template&id=a7edcecc&scoped=true&"
import script from "./BundleSelection.vue?vue&type=script&lang=ts&"
export * from "./BundleSelection.vue?vue&type=script&lang=ts&"
import style0 from "./BundleSelection.vue?vue&type=style&index=0&id=a7edcecc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7edcecc",
  null
  
)

export default component.exports